import { getCards } from '@/features/cards/cardsActions';
import type { CardDTO } from '@/types/dto/agent';
import { createReducer } from '@reduxjs/toolkit';

type CardsState = {
  items: CardDTO[];
};

const initialState: CardsState = {
  items: [],
};

export const cardsReducer = createReducer(initialState, (builder) => {
  builder.addCase(getCards.fulfilled, (state, action) => {
    state.items = action.payload ?? [];
  });
});
